import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-178b88ac")

_pushScopeId("data-v-178b88ac")
const _hoisted_1 = { class: "flex justify-between items-center mb-1" }
const _hoisted_2 = { class: "flex divide-x-2 space-x-2 divide-gray items-end -mx-2" }
const _hoisted_3 = { class: "flex space-x-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "pl-1" }, "FILTRAR", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ui_filter_select = _resolveComponent("ui-filter-select")
  const _component_ui_filter_input = _resolveComponent("ui-filter-input")
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.filters.includes('movimiento'))
        ? (_openBlock(), _createBlock(_component_ui_filter_select, {
            key: 0,
            ref: "movimientoRef",
            label: "Movimiento",
            items: _ctx.movimientos,
            onSelected: _cache[1] || (_cache[1] = evt => _ctx.filter.movimiento = evt)
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      (_ctx.filters.includes('desde'))
        ? (_openBlock(), _createBlock(_component_ui_filter_input, {
            key: 1,
            ref: "desdeRef",
            label: "Desde",
            onSelected: _cache[2] || (_cache[2] = evt => _ctx.filter.desde = evt)
          }, null, 512))
        : _createCommentVNode("", true),
      (_ctx.filters.includes('hasta'))
        ? (_openBlock(), _createBlock(_component_ui_filter_input, {
            key: 2,
            ref: "hastaRef",
            label: "Hasta",
            onSelected: _cache[3] || (_cache[3] = evt => _ctx.filter.hasta = evt)
          }, null, 512))
        : _createCommentVNode("", true),
      (_ctx.filters.includes('tipoCancha'))
        ? (_openBlock(), _createBlock(_component_ui_filter_select, {
            key: 3,
            ref: "tipoRef",
            label: "Tipo Cancha",
            items: _ctx.tipos,
            onSelected: _cache[4] || (_cache[4] = evt => _ctx.filter.tipoCancha = evt)
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      (_ctx.filters.includes('origen'))
        ? (_openBlock(), _createBlock(_component_ui_filter_select, {
            key: 4,
            ref: "origenRef",
            label: "Cancha",
            items: _ctx.canchas,
            onSelected: _cache[5] || (_cache[5] = evt => _ctx.filter.origen = evt)
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      (_ctx.filters.includes('ruma'))
        ? (_openBlock(), _createBlock(_component_ui_filter_select, {
            key: 5,
            ref: "rumaRef",
            label: "Rumas",
            items: _ctx.rumas,
            onSelected: _cache[6] || (_cache[6] = evt => _ctx.filter.ruma = evt)
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      (_ctx.filters.includes('estado'))
        ? (_openBlock(), _createBlock(_component_ui_filter_select, {
            key: 6,
            ref: "estadoRef",
            label: "Estado",
            items: _ctx.estados,
            onSelected: _cache[7] || (_cache[7] = evt => _ctx.filter.estado = evt)
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      (_ctx.filters.includes('estadoRuma'))
        ? (_openBlock(), _createBlock(_component_ui_filter_select, {
            key: 7,
            ref: "estadoRumaRef",
            label: "Estado Ruma",
            items: _ctx.estadoRumas,
            onSelected: _cache[8] || (_cache[8] = evt => _ctx.filter.estadoRuma = evt),
            default: "60dfe7c9ba0ccfd21a8e04f3"
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: "border-2 cursor-pointer rounded px-1 text-green-600 border-green-600 hover:bg-gray-100",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('filter', _ctx.filter)))
      }, [
        _createVNode(_component_fa_icon, { icon: ['fas', 'check'] }),
        _hoisted_4
      ]),
      _createVNode("div", {
        class: "selection-btn text-red-600 border-red-600",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.unfilter && _ctx.unfilter(...args)))
      }, [
        _createVNode(_component_fa_icon, { icon: ['fas', 'times'] })
      ])
    ])
  ]))
})